import React, { Component } from 'react';
import { Input, Table, Typography, Tabs, Switch } from 'antd';
import { BrowserRouter as Router, Link, Route } from 'react-router-dom';
import { isEmpty } from 'lodash';
import consts, { PREFIX_FRONT_URL } from '../../consts';
import utils from '../../common/utils';
import UserDetailContainer from '../../containers/UserDetailContainer';
import DisplayControl from '../DisplayControl';

const { Search } = Input;
const { Text } = Typography;
const { TabPane } = Tabs;

class ListUser extends Component {
  
  columns = [
    {
      align: 'center',
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      ellipsis: true
    },
    {
      align: 'center',
      title: 'Số điện thoại',
      dataIndex: 'phone',
      key: 'phone',
    },
    {
      align: 'center',
      title: 'Pubkey',
      dataIndex: 'pubkey',
      key: 'pubkey',
      width: 550,
    },
    {
      align: 'center',
      title: 'Ngày đăng ký',
      dataIndex: 'registration_date',
      key: 'registration_date',
      width: 200,
    },
    {
      title: 'Xác thực gmail',
      align: 'center',
      dataIndex: 'accuracyGmail',
      key: 'accuracyGmail',
      render: () => (
        <Switch
          height={16}
          width={30}
          checkedIcon={false}
          uncheckedIcon={false}
          onChange={this.handleToggledGmailChange}
          checked={false}
          onColor="#6AA84F"
          offColor="#bbbbbb"
          disabled
        />
      ),
    },
    {
      align: 'center',
      title: 'Block tài khoản',
      dataIndex: 'is_banned',
      key: 'is_banned',
      render: (text,record) =>  (
        <div>
          <DisplayControl
            permission_link_screen={[
              {permission:consts.AUTH.USER__LOCK__pUBKEY,action: consts.CONTROLS.PUT},
              {permission:consts.AUTH.USER__UNLOCK__pUBKEY,action: consts.CONTROLS.PUT}
              ]}>
            <Switch
              height={16}
              width={30}
              checkedIcon={false}
              uncheckedIcon={false}
              onChange={(value) => {this.handleToggledAccountChange(value,record)}}
              checked={text}
              onColor="#6AA84F"
              offColor="#bbbbbb"
            />
          </DisplayControl>
          
        </div>
      ),
    },
    {
      title: 'Hành động',
      dataIndex: 'pubkey',
      key: 'pubkey',
      render: (pubkey) => <Link to={`${PREFIX_FRONT_URL}/${window.c.routes.LIST_USERS}/${pubkey}`}>Chi
        tiết</Link>,
    },
  ];
  
  columnsSystem = [
    {
      align: 'center',
      title: 'Ảnh đại diện',
      dataIndex: 'avatar',
      key: 'avatar',
      width: 100,
      render: (avatar) => <img src={avatar} width={40}/>
    },
    {
      align: 'center',
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      ellipsis: true
    },
    {
      align: 'center',
      title: 'Tên',
      dataIndex: 'displayName',
      key: 'displayName',
      ellipsis: true
    },
    {
      align: 'center',
      title: 'Số điện thoại',
      dataIndex: 'phone',
      key: 'phone',
    },
    {
      align: 'center',
      title: 'Pubkey',
      dataIndex: 'pubkey',
      key: 'pubkey',
      ellipsis: true,
      width: 400,
    },
    {
      align: 'center',
      title: 'Xác thực điện thoại',
      dataIndex: 'extend.is_verify',
      key: 'is_verify',
      render: (isBanned) => (
        <div>
          <Switch
            height={16}
            width={30}
            checkedIcon={false}
            uncheckedIcon={false}
            onChange={this.handleToggledAccountChange}
            checked={isBanned}
            onColor="#6AA84F"
            offColor="#bbbbbb"
          />
          {/* <span> {intl.formatMessage({ id: 'collapsed' })}</span> */}
        </div>
      ),

    },
  ];
  
  constructor(props) {
    super(props);
    this.state = {
      toggledAccount: false,
      toggledGmail: true,
      totalCount: 0,
      totalCountSystem: 0,
      currentPage: 1,
      isLoading: false,
      visible: false,
      error: '',
      onSearchValue: '',
      onSearchSystemValue: '',
      tab: '1',
    };
    
  }
  
  componentDidMount() {
    this.fetchData();
  }
  
  fetchData = (pos = 0, count = consts.DEFAULT_PAGE_SIZE, isRefresh = false) => {
    this.setState({ isLoading: true });
    if (isRefresh) {
      this.filter = {
        ...this.filter,
        pos: 0,
        count: consts.DEFAULT_PAGE_SIZE,
      };
      this.setState({ currentPage: 1, });
    } else {
      this.filter = {
        ...this.filter,
        pos,
        count,
      };
    }
    if (this.state.tab === '1') {
      this.props.userListAction(this.filter, this.updateTotalCount);
    } else {
      this.props.userSystemListAction(this.filter, this.updateTotalCount);
    }
  };
  
  updateTotalCount = (totalCount) => {
    if (this.state.tab === '1') {
      this.setState({
        totalCount,
        isLoading: false
      });
    } else {
      this.setState({
        totalCountSystem: totalCount,
        isLoading: false
      });
    }
  };
  
  handleToggledAccountChange = (value, record) => {
    this.setState({isLoading:true})
    if(value){
      this.props.lockUser(record, this.fetchUserInfo)
    }else{
      this.props.unlockUser(record, this.fetchUserInfo)
    }
  };

  handleToggledGmailChange = (toggledGmail) => {
    this.setState({
      toggledGmail,
    });
  };
  
  showDetail = (pubkey) => {
    this.setState({ visible: true });
  };
  
  onSearchUser = (pubkey, event) => {
    if (isEmpty(pubkey)) {
      this.setState({
        onSearchValue: '',
      }, this.fetchData);
      return
    }
    if (this.state.onSearchValue) {
      this.setState({
        totalCount: 0,
        currentPage: 1,
      });
      this.props.userInfoAction(this.state.onSearchValue);
    }
  
  };
  
  onSearchUserSystem = (pubkey, event) => {
    if (!pubkey) {
      this.setState({
        onSearchSystemValue: '',
      }, this.fetchData);
      return
    }
    if (this.state.onSearchSystemValue) {
      this.setState({
        totalCount: 0,
        totalCountSystem: 0,
        currentPage: 1,
      });
      this.props.userSystemInfoAction({ pubkey: this.state.onSearchSystemValue });
    }
  };
  
  onChangeTabs = (activeKey) => {
    this.setState({
      tab: activeKey,
      currentPage: 1,
      onSearchValue: '',
      onSearchSystemValue: '',
    }, this.fetchData);
  };
  
  onChange = (e) => {
    if (this.state.tab === '1') {
      this.setState({
        onSearchValue: e.target.value
      });
    } else {
      this.setState({
        onSearchSystemValue: e.target.value
      });
    }
  };
  
  render() {
    const { error, onSearchValue, tab, totalCountSystem, currentPage, isLoading, onSearchSystemValue, totalCount } = this.state;
    const {
      users,
      userInfo,
      userSystemList,
      userSystemInfo,
    } = this.props;
    console.log(userInfo, ': userInfo src/component/ListUser/ListUsers.jsx:301');
    console.log(userSystemInfo, ': userInfo src/component/ListUser/ListUsers.jsx:302');
    
    return (
      <Router>
        <>
          <Route exact path={`${PREFIX_FRONT_URL}/${window.c.routes.LIST_USERS}`}>
            <div className="list-user">
              <div className="d-flex align-items justify-end">
                <span
                  className="mr-medium">{tab === '1' ? 'Tìm kiếm người dùng sàn' : 'Tìm kiếm người dùng hệ thống'}</span>
                <Search
                  name="pubkey"
                  value={tab === '1' ? onSearchValue : onSearchSystemValue}
                  placeholder="Nhập pubkey..."
                  onChange={this.onChange}
                  onSearch={tab === '1' ? this.onSearchUser : this.onSearchUserSystem} allowClear
                  enterButton style={{ width: '40%' }}/>
                <div className="text-left p-abs no-wrap">
                  <Text type='danger'>{utils.upperCaseFirst(error || '')}</Text>
                </div>
              </div>
              <Tabs defaultActiveKey="1" onChange={this.onChangeTabs}>
                <TabPane tab="Danh sách người dùng sàn" key="1">
                  <Table dataSource={!isEmpty(userInfo) ? [userInfo] : users} columns={this.columns}
                         pagination={{
                           current: currentPage,
                           onChange: (page, pageSize) => {
                             this.setState({
                               isLoading: true,
                               currentPage: page,
                             });
                             this.fetchData((page - 1) * pageSize, pageSize);
                           },
                           defaultPageSize: consts.DEFAULT_PAGE_SIZE,
                           total: totalCount,
                           hideOnSinglePage: true,
                         }} bordered
                         loading={isLoading}
                  />
                </TabPane>
                <TabPane tab="Danh sách toàn hệ thống" key="2">
                  <Table dataSource={!isEmpty(userSystemInfo) ? [userSystemInfo] : userSystemList}
                         columns={this.columnsSystem}
                         pagination={{
                           current: currentPage,
                           onChange: (page, pageSize) => {
                             this.setState({
                               isLoading: true,
                               currentPage: page,
                             });
                             this.fetchData((page - 1) * pageSize, pageSize);
                           },
                           defaultPageSize: consts.DEFAULT_PAGE_SIZE,
                           total: totalCountSystem,
                           hideOnSinglePage: true,
                         }} bordered
                         loading={isLoading}
                  />
                </TabPane>
              </Tabs>
            
            </div>
          </Route>
          
          <Route exact path={`${PREFIX_FRONT_URL}/${window.c.routes.LIST_USERS}/:id`}>
            <UserDetailContainer/>
          </Route>
        </>
      </Router>
    );
  }
}

export default ListUser;
